import React, { useEffect } from "react";
import {
  Card,
  Switch,
  Input,
  Button,
  Form,
  message,
  Row,
  Col,
  Divider,
} from "antd";
import { updateAdminSecurity, updateAdminSetting } from "../../api/SettingApi";

export default function SecurityTab({ adminSetting, fetchSettings }) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(adminSetting);
  }, [adminSetting]);

  const saveSection = async () => {
    try {
      const values = await form.validateFields();
      await updateAdminSecurity(values);
      fetchSettings();
      message.success("Security settings saved");
    } catch {
      message.error("Validation failed");
    }
  };

  return (
    <Form form={form} layout="vertical">
      <Row gutter={[16, 16]}>
        {/* Security Settings */}
        <Col xs={24} md={12}>
          <Card title="Security Settings" style={{ marginBottom: 24 }}>
            <Row align="middle" gutter={[16, 12]}>
              {/* Enable 2FA */}
              <Col xs={18} sm={20}>
                <div style={{ fontWeight: 300 }}>Enable 2FA for Admin</div>
              </Col>
              <Col xs={6} sm={4}>
                <Form.Item
                  name="enable2FAForAdmin"
                  valuePropName="checked"
                  style={{ margin: 0 }} // remove default bottom margin so it lines up nicely
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Divider style={{ margin: "8px 0" }} />
              </Col>
              {/* IP Restriction */}
              <Col xs={18} sm={20}>
                <div style={{ fontWeight: 300 }}>IP Restriction</div>
              </Col>
              <Col xs={6} sm={4}>
                <Form.Item
                  name="ipRestriction"
                  valuePropName="checked"
                  style={{ margin: 0 }}
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Divider style={{ margin: "8px 0" }} />
              </Col>
              {/* Auto Logout */}
              <Col xs={18} sm={20}>
                <div style={{ fontWeight: 300 }}>Auto Logout (30 min)</div>
              </Col>
              <Col xs={6} sm={4}>
                <Form.Item
                  name="autoLogout"
                  valuePropName="checked"
                  style={{ margin: 0 }}
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Divider style={{ margin: "8px 0" }} />
              </Col>
              {/* Max Login Attempts — keep this full width below */}
              <Col span={24}>
                <Form.Item
                  name="maxLoginAttempts"
                  label="Max Login Attempts"
                  rules={[{ required: true, message: "Enter max attempts" }]}
                >
                  <Input type="number" min={1} />
                </Form.Item>
              </Col>

              {/* Save button */}
              <Col span={24}>
                <Button type="primary" onClick={saveSection}>
                  Save Security Settings
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Notification Settings */}
        <Col xs={24} md={12}>
          <Card title="Notification Settings">
            <Row align="middle" gutter={[16, 12]}>
              {/* Email Alerts */}
              <Col xs={18} sm={20}>
                <div style={{ fontWeight: 300 }}>Email Alerts</div>
              </Col>
              <Col xs={6} sm={4}>
                <Form.Item
                  name="emailAlerts"
                  valuePropName="checked"
                  style={{ margin: 0 }}
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Divider style={{ margin: "8px 0" }} />
              </Col>
              {/* SMS Alerts */}
              <Col xs={18} sm={20}>
                <div style={{ fontWeight: 300 }}>SMS Alerts</div>
              </Col>
              <Col xs={6} sm={4}>
                <Form.Item
                  name="smsAlerts"
                  valuePropName="checked"
                  style={{ margin: 0 }}
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Divider style={{ margin: "8px 0" }} />
              </Col>
              <Col xs={18} sm={20}>
                <div style={{ fontWeight: 300 }}>Whatsapp Alerts</div>
              </Col>
              <Col xs={6} sm={4}>
                <Form.Item
                  name="whatsappAlerts"
                  valuePropName="checked"
                  style={{ margin: 0 }}
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Divider style={{ margin: "8px 0" }} />
              </Col>
              {/* High Value Transactions */}
              <Col xs={18} sm={20}>
                <div style={{ fontWeight: 300 }}>High Value Transactions</div>
              </Col>
              <Col xs={6} sm={4}>
                <Form.Item
                  name="highValueTransactions"
                  valuePropName="checked"
                  style={{ margin: 0 }}
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Divider style={{ margin: "8px 0" }} />
              </Col>
              {/* Failed Login Attempts */}
              <Col xs={18} sm={20}>
                <div style={{ fontWeight: 300 }}>Failed Login Attempts</div>
              </Col>
              <Col xs={6} sm={4}>
                <Form.Item
                  name="failedLoginAttempts"
                  valuePropName="checked"
                  style={{ margin: 0 }}
                >
                  <Switch />
                </Form.Item>
              </Col>

              {/* Save button */}
              <Col span={24} className="mt-5">
                <Button type="primary" onClick={saveSection}>
                  Save Notifications
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Form>
  );
}
